module.exports = __webpack_public_path__ + "img/编组 54.eef51ff8.png";